<!--
* @description:
* @fileName tpl-banner.vue
* @author hvv
* @date 2022/01/11 13:13:31
!-->
<template>
  <div class="layout">
    <div class="search">
      <el-icon><search /></el-icon>
      {{ res.list[0].title }}
    </div>
  </div>
</template>

<script>
  import { defineAsyncComponent, defineComponent, getCurrentInstance, onMounted, reactive, toRefs, watch } from 'vue'
  export default defineComponent({
    name: 'TplSearch',
    props: {
      res: Object,
    },
    setup(props, { emit }) {
      const { proxy } = getCurrentInstance

      const state = reactive({
        nowItem: {},
        fit: 'fill',
      })
      onMounted(() => {
        // proxy.nowItem = props.res

        console.log(props.res)
      })
      watch(
        () => props.res,
        (newVal, oldVal) => {
          console.log(newVal, oldVal, '123123123')
        }
      )

      return {
        ...toRefs(state),
      }
    },
  })
</script>
<style lang="scss" scoped>
  @import './tpl.scss';
  .search {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 32px;
    background: #ededed;
    border-radius: 5px;
  }
</style>
